export default function stringIsEqual(a, b) {
  const left = `${a || ''}`.trim().toLowerCase();
  const right = `${b || ''}`.trim().toLowerCase();
  return left === right;
}
